// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/wei/WEI/浙建科技/重点项目/工地天眼/源码/bm-main/src/models/excel';
import model_2 from '/Users/wei/WEI/浙建科技/重点项目/工地天眼/源码/bm-main/src/models/global';
import model_3 from '/Users/wei/WEI/浙建科技/重点项目/工地天眼/源码/bm-main/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'excel', model: model_1 },
model_2: { namespace: 'global', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
